'use client';

// Vendors
import { signIn } from 'next-auth/react';

// React icons
import { FcGoogle } from 'react-icons/fc';

// global UI components
import { Button } from '@/components/ui/button';

// ROUTES
import { DEFAULT_LOGIN_REDIRECT } from '@/routes';
import { useTranslations } from '@/hooks/useTranslations';

export const Social = () => {
  const t = useTranslations('LoginForm');

  const onClick = (provider: 'google' | 'github') => {
    signIn(provider, {
      callbackUrl: DEFAULT_LOGIN_REDIRECT,
    });
  };
  return (
    <div className="flex items-center flex-col w-full gap-y-2 md:gap-x-2">
      <Button
        aria-label="Google login"
        size="lg"
        className="w-full flex justify-center items-center gap-2"
        variant="outline"
        onClick={() => onClick('google')}
      >
        <FcGoogle className="h-8 w-8" />

        <h6 className="text-sm font-semibold">{t('googleLabel')}</h6>
      </Button>
    </div>
  );
};
